<template>
  <div class="form-group" :class="{ 'has-error': errors.has(name) }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <date-time-picker
      ref="input"
      :id="id"
      :name="name"
      :value="value"
      :disabled="disabled"
      range-separator="-"
      inputClass="form-control"
      :local="local"
      :format="format"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event), changeFocus()"
      @focus="changeFocus()"
    />
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import DateTimePicker from "./DateTimePicker";

export default {
  inject: ["$validator"],
  name: "form-group-date-time-picker",
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: [String, Array, Date],
    format: {
      type: String,
      default: "DD/MM/YYYY"
    }
  },
  components: {
    DateTimePicker
  },
  data() {
    return {
      active: false,
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Selecione a Hora", // tip of select hour
        minuteTip: "Selecione o Minuto", // tip of select minute
        secondTip: "Selecione o Segundo", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ], // months of head
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez"
        ], // months of panel
        weeks: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"], // weeks,
        cancelTip: "Cancelar",
        submitTip: "Confirmar"
      }
    };
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupDateTimePicker.vue